import type { AdverseCredit } from '@/types/adverseCredit'

export const toAdverseCreditPayload = (adverseCredit: AdverseCredit): AdverseCredit => ({
  id: adverseCredit.id,
  state: adverseCredit.state,
  declaration: adverseCredit.declaration,
  amount: adverseCredit.amount,
  courtDate: adverseCredit.courtDate,
  caseNumber: adverseCredit.caseNumber,
  type: adverseCredit.type,
})
